import {Text, OtpInput, Button} from 'ui-kits';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {getAuthError} from 'redux/selectors/authSelector';
import {ErrorCodes} from 'utils/getMessages';
import {FormikProps} from 'formik';
import {View, TouchableOpacity, Pressable, StyleSheet} from 'react-native';
import {spacing} from 'theme/Units';
import colors from 'theme/Colors';
import {defaultOTPlength} from 'constants/DefaultValues';

export type initialOTPValueType = {
  otp: string;
};

type OtpFormPropType = Readonly<{
  canResendOTP: boolean;
  attemptsLeft: number;
  remainingTime: number;
  handleResendOTP: () => void;
  heading?: string;
  label: string;
  buttonText: string;
} & FormikProps<initialOTPValueType>>;

export function OtpForm(props: OtpFormPropType) {
  const {
    attemptsLeft,
    canResendOTP,
    remainingTime,
    handleChange,
    values,
    errors,
    handleBlur,
    handleResendOTP,
    handleSubmit,
    setValues,
    heading,
    label,
    buttonText,
  } = props;
  const errorSignIn = useSelector(getAuthError) as ErrorCodes;

  useEffect(() => {
    if (['E-10085', 'E-10084', 'E-10010', 'E-10004'].includes(errorSignIn)) {
      setValues({otp: ''});
    }
  }, [errorSignIn, setValues]);

  return (
    <View style={styles.otpForm}>
      {heading && (
        <Text style={styles.mailHeader} variant={'sourcesans18m'}>
          {heading}
        </Text>
      )}
      <Text style={styles.otpLabel} variant="sourcesans16m">
        {label}
      </Text>
      <OtpInput
        value={values.otp}
        onChange={handleChange('otp')}
        onBlur={handleBlur('otp')}
        error={errors.otp}
        length={defaultOTPlength}
      />
      <View style={styles.actionTextWrapper}>
        <TouchableOpacity disabled={!canResendOTP} onPress={handleResendOTP}>
          <Text
            style={[
              styles.resendOtp,
              canResendOTP ? styles.otpAttempts : null,
            ]}>
            Didn't receive OTP ?
          </Text>
        </TouchableOpacity>
        {remainingTime > 0 ? (
          <Pressable>
            <Text style={[styles.resendOtp, styles.otpTimer]}>
              Resend OTP in {remainingTime} secs...
            </Text>
          </Pressable>
        ) : null}
      </View>
      <Button
        text={buttonText}
        disabled={values.otp?.length !== defaultOTPlength}
        onPress={handleSubmit}
        style={styles.submitButton}
      />
      <Text style={styles.otpAttempts} variant="sourcesans16m">
        You have {attemptsLeft} attempts left.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  otpForm: {
    gap: spacing['4'],
  },
  otpLabel: {
    color: colors.palette.neutralN700,
    textAlign: 'center',
  },
  otpTimer: {
    fontWeight: 600,
    color: colors.palette.black,
  },
  resendOtp: {
    color: colors.palette.nuetral4Placeholder,
  },
  otpAttempts: {
    color: colors.palette.blue600,
    textAlign: 'center',
  },
  mailHeader: {
    fontWeight: 600,
  },
  submitButton: {
    width: '100%',
    paddingHorizontal: spacing['4'],
  },
  actionTextWrapper: {
    flexDirection: 'row',
    gap: spacing['4'],
    justifyContent: 'center',
  },
});
